import React, {useContext, useState} from 'react';
import {
	Avatar, Dialog, DialogContent, DialogTitle,
	Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import {innerStyle} from "../../../../styles/pages/home/MaterialYouBaseStyle";
import logo from "../../../../assets/v2/Logo-Orca.svg";
import {AzioniPaper} from "./azioni/AzioniPaper";
import {MessaggiPaper} from "./messaggi/MessaggiPaper";
import {CalendarioPaper} from "./eventi/CalendarioPaper";
import {EventiPaper} from "./eventi/EventiPaper";
import {ProfiloPaper} from "./profilo/ProfiloPaper";
import {indigo} from "@mui/material/colors";
import {AppContext} from "../../../../App";
import IconButton from "@mui/material/IconButton";
import WbSunnyTwoToneIcon from '@mui/icons-material/WbSunnyTwoTone';
import NightsStayTwoToneIcon from '@mui/icons-material/NightsStayTwoTone';
import {setThemeType} from "../../../../services/AppServices";
import ChatFab from "../../../widgets/chat/ChatFab";

const NewHome = () => {
	const classes = innerStyle();
	const appContext = useContext(AppContext);
	const [open, setOpen] = useState(false)
	
	return (
        <React.Fragment>
            <main className={classes.main}>
				<header style={{
					display: "flex",
					justifyContent: "center",
					paddingBottom: 28,
					paddingTop: 20,
				}}>
					<Avatar src={logo} variant="circular" className={classes.logo}/>
					<Typography variant={"h1"} component={"h1"} align={"center"}
					            style={{color: indigo["A700"]}}>
						<b>
							<span style={{color: indigo["A700"]}}>c</span>
							<span style={{color: indigo["A700"]}}>e</span>
							<span style={{color: indigo["A700"]}}>a</span>
							<span style={{color: indigo["A700"]}}>n</span>
						</b>
					</Typography>
				</header>
				<Grid container spacing={4} component={"article"} style={{padding: 20}}>
					
					<Grid item xs={12} md={7}>
						
						<Grid container spacing={3}>
							<Grid item xs={12}>
								<AzioniPaper/>
							</Grid>
							
							<Grid item xs={12}>
								<MessaggiPaper/>
							</Grid>
						
						</Grid>
					</Grid>
					<Grid item xs={12} md={5}>
						<Grid container spacing={3}>
							
							<Grid item xs={12}>
								<ProfiloPaper/>
							</Grid>
							
							<Grid item xs={12}>
								<CalendarioPaper/>
							</Grid>
							
							<Grid item xs={12}>
								<EventiPaper/>
							</Grid>
						
						
						</Grid>
					</Grid>
					<Grid item xs={12}
					      style={{
						      display: "flex",
						      alignItems: "center",
						      alignContent: "center",
						      justifyContent: "center",
						      position: "relative"
					      }}>
						<Typography variant={"caption"} color={"textSecondary"} align={"center"}
						            className={classes.underlineOnHover} onClick={() => setOpen(true)}>
							Atlantis© 2022 v5.0.0.0<br/>
							Atlantis S.p.A 2022-2027<br/>
							Via San Paolo 33, Torino, TO
						</Typography>
						
						<IconButton
                            style={{position: "absolute", right: 4, bottom: 4}}
                            onClick={() => setThemeType(appContext.state.theme.palette.mode === "light" ? "dark" : "light",
                                appContext.state.theme, appContext.dispatch)}
                            size="large">
							{appContext.state.theme.palette.mode === "light" ? <NightsStayTwoToneIcon/> : <WbSunnyTwoToneIcon/>}
						</IconButton>
					</Grid>
				</Grid>
				
				<ChatFab/>
			
			</main>
            {
				open && <Dialog open={open} onClose={() => setOpen(false)} maxWidth={"md"} scroll={"paper"} PaperProps={{
					className: classes.paper
				}}>
					<DialogTitle>
						Ocean v5.0.0.0
					</DialogTitle>
					<DialogContent>
						Verifica la disponibilità di aggiornamenti
					</DialogContent>
					cose stupide...
				</Dialog>
			}
        </React.Fragment>
    );
}

export default React.memo(NewHome);
